import { WorkItemInfo } from 'runtime/data/workiteminfo';

export class SearchResult extends WorkItemInfo {
    score: number;
}